import { mixin as clickAway } from 'vue-clickaway';
import { createNamespacedHelpers } from 'vuex';

import ConciergeList from '@/components/concierge_list/ConciergeList.vue';

import LayoutDefs from '@/store/layout/layout.d';

const { mapActions: mapLayoutActions } = createNamespacedHelpers('Layout');

export default {
  name: 'TransferModal',
  mixins: [clickAway],
  components: { ConciergeList },
  methods: {
    ...mapLayoutActions({
      layoutStore_closeModal: LayoutDefs.actions.closeModal
    }),

    closeTransferModal: function() {
      this.layoutStore_closeModal({ module: 'transfer' });
    }
  }
};
